import { systemTypography } from './system.js';
import { componentTypography } from './component.js';
export const typographyTokenMapping = {
    sys: systemTypography,
    cmp: componentTypography
};
//# sourceMappingURL=index.js.map